import browser from "webextension-polyfill";
import { messageIdentifier, cookieBannerEventNames } from "../shared";
function forwardEvent(name) {
    void browser.runtime.sendMessage({ type: messageIdentifier, name });
}
export function start() {
    [
        cookieBannerEventNames.cpmMessageDetected,
        cookieBannerEventNames.buttonInjected,
        cookieBannerEventNames.buttonClicked,
    ].forEach((eventName) => {
        document.addEventListener(eventName, () => {
            forwardEvent(eventName);
        });
    });
}
start();
